import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';

import '../../scss/main.scss';
import Admin from './components/Admin.jsx';

ReactDOM.render(
  <Admin />,
  document.getElementById('root'),
);
